import React, { useEffect } from 'react';
import { LegalPage } from './LegalPage';
const sections = [{
  title: '1. Introduction',
  content: 'Welcome to 888 Sourcing Limited ("we", "us", "our"). By accessing or using our website and services, you agree to be bound by these Terms of Service. If you do not agree, please do not use our website.'
}, {
  title: '2. Services',
  content: 'We provide B2B sourcing, negotiation, supply, and distribution services connecting manufacturers and producers with retailers across the UK, Europe, and Asia. We reserve the right to modify or discontinue services at any time without prior notice.'
}, {
  title: '3. Use of Website',
  content: ['You agree to use this website lawfully and not to:', '• Engage in any activity that may harm, disrupt, or compromise the website', '• Access or attempt to access unauthorized areas or data', '• Post or transmit unlawful, harmful, or offensive content']
}, {
  title: '4. Account Responsibility',
  content: 'If you create an account or provide credentials, you are responsible for maintaining the confidentiality of your login information and all activities conducted under your account.'
}, {
  title: '5. Intellectual Property',
  content: 'All content, trademarks, logos, and materials on this website are owned or licensed by 888 Sourcing Limited. You may not reproduce, distribute, or use any content without prior written permission.'
}, {
  title: '6. Limitation of Liability',
  content: 'While we aim to provide accurate and reliable information, 888 Sourcing Limited is not liable for any direct, indirect, or consequential loss arising from your use of this website or our services. We do not guarantee the accuracy or completeness of information provided by third parties.'
}, {
  title: '7. Third-Party Links',
  content: 'Our website may include links to third-party websites. We are not responsible for the content or practices of such sites, and inclusion of any link does not imply endorsement.'
}, {
  title: '8. Privacy',
  content: 'Your use of our website is also governed by our Privacy Policy, which forms part of these Terms of Service.'
}, {
  title: '9. Governing Law and Jurisdiction',
  content: 'These Terms of Service are governed by the laws of England and Wales. Any disputes arising from the use of our website or services will be subject to the exclusive jurisdiction of the courts of England and Wales.'
}, {
  title: '10. Changes to Terms',
  content: 'We reserve the right to modify these Terms of Service at any time. Updated versions will be posted on this page with the effective date. Continued use of the website constitutes acceptance of the revised terms.'
}];
export function TermsOfServicePage() {
  useEffect(() => {
    document.title = 'Terms of Service | 888 Sourcing Limited';
    window.scrollTo(0, 0);
  }, []);
  return <LegalPage title="Terms of Service" lastUpdated="January 2024" sections={sections} showContactInfo={true} data-id="element-678" />;
}